module.exports = __webpack_public_path__ + "img/PROTESIS_BUEN_ESTADO.png";